/**
 * @deprecated use from @sparelabs/currency instead
 */
export { Currency } from '@sparelabs/currency'
